<template>
    <div class="q-summit-sidebar">
        <QSummitSidebarHeader :totalSteps="totalSteps" :currentStep="currentStepIndex" :stepCategory="currentCategory" />
        <div class="q-summit-sidebar__content">
            <QSummitGuide :steps="steps" :current-step="currentStep" />
        </div>
    </div>
</template>

<script>
import SummitNav from '@/store/Models/SummitNav'
import QSummitSidebarHeader from "./QSummitSidebarHeader.vue"
import QSummitGuide from "./QSummitGuide.vue"

export default {
    components: { QSummitSidebarHeader, QSummitGuide },

    computed: {
        steps() { 
            return SummitNav
                .query()
                .orderBy('StepOrder')
                .get()
        },
        currentStep() { return this.steps.find((step) => step.CurrentStepInd) || this.steps[0] },
        totalSteps() { return this.currentStep ? this.currentStep.StepsInCategory : 0 },
        currentStepIndex() { return this.currentStep ? this.currentStep.StepCategoryOrder : 0 },
        currentCategory() { return this.currentStep ? this.currentStep.StepCategory : 'Activate' }
    }
}
</script>

<style lang="scss" scoped>
.q-summit-sidebar {
    display: flex;
    flex-direction: column;
    height: 100%;

    &__content {
        flex: 1;
        overflow-y: auto;
        padding-bottom: 60px;
    }
}
</style>